import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-download',
    templateUrl: './block-download.component.html',
})

export class BlockDownloadComponent extends BlockAbstractComponent implements OnInit {

    override ngOnInit() {
        super.ngOnInit();
        if (this.block.data.documentId) {
            this.block.data.documentId = this.parser.parseContent(this.block.data.documentId);
        }
    }

}
